import React from 'react';
import { motion } from 'framer-motion';
import { Wifi, Flame, UtensilsCrossed, Car, MapPin, Fish, ChefHat } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Services() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: Fish,
    title: t('Pesca deportiva', 'Sport fishing'),
    description: t('A pasos de uno de los mejores parajes para la pesca de la provincia.', 'Steps from one of the best fishing spots in the province.')
  }, {
    icon: Flame,
    title: t('Calefacción tiro balanceado', 'Balanced-flue heating'),
    description: t('Calefacción de tiro balanceado en cada cabaña, cálidas durante todo el año.', 'Balanced-flue heating in every cabin, warm all year round.')
  }, {
    icon: UtensilsCrossed,
    title: t('Quincho con parrilla', 'Quincho with grill'),
    description: t('Espacio de quincho con parrilla para compartir un asado.', 'A quincho with grill to share an asado.')
  }, {
    icon: ChefHat,
    title: t('Cocina equipada', 'Equipped kitchen'),
    description: t('Cocina con todo lo necesario para preparar tus comidas.', 'A kitchen with everything you need to prepare your meals.')
  }, {
    icon: Car,
    title: t('Estacionamiento en el predio', 'On-site parking'),
    description: t('Lugar para tu vehículo dentro del predio, sin costo adicional.', 'Space for your vehicle inside the property, at no extra cost.')
  }, {
    icon: Wifi,
    title: t('Wifi de alta velocidad', 'High-speed Wi-Fi'),
    description: t('Conexión rápida y estable, ideal para descansar o trabajar.', 'Fast, stable connection, ideal for resting or working.')
  }, {
    icon: MapPin,
    title: t('Cerca de Bariloche', 'Close to Bariloche'),
    description: t('A 15 km del Centro Cívico, el lago y los circuitos clásicos.', '15 km from the Civic Center, the lake and the classic circuits.')
  }];
  return <section id="servicios" className="py-24 bg-background" data-id="element-304" data-mp="1lklo85wqn4jy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-305" data-mp="1gqqyolugbvcy">
        <div className="max-w-2xl mb-16" data-id="element-306" data-mp="1bsxrbphewvb3">
          <span className="text-accent font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-307" data-mp="1brwh1n880cuf">
            {t('Servicios', 'Services')}
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-primary mb-4" data-id="element-308" data-mp="11urs5fmzq39x">
            {t('Todo lo que necesitás', 'Everything you need')}
          </h2>
          <p className="text-gray-600 text-lg font-light" data-id="element-309" data-mp="xtg77nf2a682">
            {t('Pensamos cada detalle para que tu estadía sea cómoda y sin preocupaciones.', 'We thought through every detail so your stay is comfortable and worry-free.')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10" data-id="element-310" data-mp="2n8meaguo1ubw">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={service.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.35,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-311" data-mp="2zom5p2yjeyp0" data-mpi={index}>
                <Icon className="w-6 h-6 text-accent mb-4" data-id="element-312" data-mp="2grulmrb68fjw" />
                <h3 className="text-base font-medium text-primary mb-2" data-id="element-313" data-mp="2lpmfhqvdmbqq">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-314" data-mp="2ptu3flu0fnnw">
                  {service.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}